// Maison JNE — scripts propios (mj-*)
// Varias secciones incluyen esta misma etiqueta <script>; este guard evita que
// se registren los listeners dos veces (y que un clic active y desactive algo
// en el mismo instante) cuando eso pasa en una misma página.
if (!window.__mjScriptsInit) {
  window.__mjScriptsInit = true;
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initGaleria();
    initVariantes();
    initCantidad();
    initFaq();
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mj-reveal');
  if (!els.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return; // ya son visibles por defecto (ver mj-styles.css), no hace falta nada
  }

  // Solo AHORA, con el JS ya corriendo, se apunta el contenido a "empieza
  // invisible y anímate al entrar en pantalla". Si algo falla después de
  // este punto (el observer no dispara en algún contexto raro de vista
  // previa, un iframe que no se pinta...), el timeout de seguridad de abajo
  // se encarga de que el contenido no se quede invisible para siempre.
  els.forEach(function (el, i) {
    el.classList.add('mj-pre-reveal');
    el.style.transitionDelay = Math.min(i % 6, 6) * 70 + 'ms';
  });

  var pendientes = els.length;
  function marcarVisible(el) {
    if (!el.classList.contains('mj-visible')) {
      el.classList.add('mj-visible');
      pendientes--;
    }
  }

  try {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            marcarVisible(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { observer.observe(el); });
  } catch (e) {
    els.forEach(marcarVisible);
    return;
  }

  // Red de seguridad: si en 1.5s el observer no reveló todo (por ejemplo
  // porque la página vive dentro de un iframe de vista previa que el
  // navegador no considera "visible"), se muestra igualmente sin animación.
  setTimeout(function () {
    if (pendientes > 0) els.forEach(marcarVisible);
  }, 1500);
}

function initGaleria() {
  document.querySelectorAll('[data-mj-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mj-galeria-principal]');
    var miniaturas = galeria.querySelectorAll('[data-mj-galeria-miniatura]');
    if (!principal || !miniaturas.length) return;

    miniaturas.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var url = mini.getAttribute('data-mj-full');
        if (!url) return;
        principal.setAttribute('src', url);
        miniaturas.forEach(function (m) { m.classList.remove('mj-activa'); });
        mini.classList.add('mj-activa');
      });
    });
  });
}

function initVariantes() {
  document.querySelectorAll('[data-mj-producto]').forEach(function (wrap) {
    var dataEl = wrap.querySelector('[data-mj-variantes-json]');
    if (!dataEl) return;

    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var idInput = wrap.querySelector('[data-mj-variant-id]');
    var precioEl = wrap.querySelector('[data-mj-precio]');
    var precioAntesEl = wrap.querySelector('[data-mj-precio-antes]');
    var botonComprar = wrap.querySelector('[data-mj-comprar]');
    var notaStock = wrap.querySelector('[data-mj-nota-stock]');
    var grupos = wrap.querySelectorAll('[data-mj-opcion-grupo]');

    function opcionesSeleccionadas() {
      var seleccion = [];
      grupos.forEach(function (grupo) {
        var activa = grupo.querySelector('.mj-seleccionada');
        seleccion.push(activa ? activa.getAttribute('data-mj-valor') : null);
      });
      return seleccion;
    }

    function encontrarVariante() {
      var seleccion = opcionesSeleccionadas();
      return variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
    }

    function formatoMoneda(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD'
      });
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) return;

      if (idInput) idInput.value = variante.id;
      if (precioEl) precioEl.textContent = formatoMoneda(variante.price);
      if (precioAntesEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAntesEl.textContent = formatoMoneda(variante.compare_at_price);
          precioAntesEl.style.display = '';
        } else {
          precioAntesEl.style.display = 'none';
        }
      }
      if (botonComprar) {
        botonComprar.disabled = !variante.available;
        botonComprar.textContent = variante.available
          ? botonComprar.getAttribute('data-mj-texto-disponible')
          : botonComprar.getAttribute('data-mj-texto-agotado');
      }
      if (notaStock) {
        notaStock.textContent = variante.available
          ? notaStock.getAttribute('data-mj-texto-disponible') || ''
          : notaStock.getAttribute('data-mj-texto-agotado') || '';
      }

      grupos.forEach(function (grupo) {
        var opcionIndex = Number(grupo.getAttribute('data-mj-opcion-grupo'));
        var seleccion = opcionesSeleccionadas();
        grupo.querySelectorAll('[data-mj-valor]').forEach(function (pill) {
          var valor = pill.getAttribute('data-mj-valor');
          var combinacion = seleccion.slice();
          combinacion[opcionIndex] = valor;
          var existe = variantes.some(function (v) {
            return v.options.every(function (opt, i) {
              return combinacion[i] === null || opt === combinacion[i];
            });
          });
          pill.disabled = !existe;
        });
      });
    }

    grupos.forEach(function (grupo) {
      grupo.querySelectorAll('[data-mj-valor]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.disabled) return;
          grupo.querySelectorAll('[data-mj-valor]').forEach(function (p) { p.classList.remove('mj-seleccionada'); });
          pill.classList.add('mj-seleccionada');
          actualizar();
        });
      });
    });

    actualizar();
  });
}

function initCantidad() {
  document.querySelectorAll('[data-mj-cantidad]').forEach(function (control) {
    var input = control.querySelector('input');
    var menos = control.querySelector('[data-mj-menos]');
    var mas = control.querySelector('[data-mj-mas]');
    if (!input) return;

    menos && menos.addEventListener('click', function () {
      var val = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.value = val;
    });
    mas && mas.addEventListener('click', function () {
      var val = parseInt(input.value || '1', 10) + 1;
      input.value = val;
    });
  });
}

function cerrarFaqItem(item) {
  item.setAttribute('data-abierto', 'false');
  var resp = item.querySelector('.mj-faq__respuesta');
  if (resp) resp.style.maxHeight = '';
}

function abrirFaqItem(item) {
  item.setAttribute('data-abierto', 'true');
  var resp = item.querySelector('.mj-faq__respuesta');
  if (resp) resp.style.maxHeight = resp.scrollHeight + 'px';
}

function initFaq() {
  // El max-height se controla desde aquí (en vez de dejarlo solo en el CSS)
  // porque esta hoja de estilos se incluye varias veces en la misma página
  // (una por cada sección) y eso puede hacer que la regla condicional del
  // CSS no gane la cascada de forma fiable. Un estilo puesto por JS con
  // .style siempre gana, así que la respuesta se ve seguro.
  document.querySelectorAll('[data-mj-faq-item]').forEach(function (item) {
    var pregunta = item.querySelector('[data-mj-faq-pregunta]');
    if (!pregunta) return;
    pregunta.addEventListener('click', function () {
      var abierto = item.getAttribute('data-abierto') === 'true';
      var contenedor = item.closest('[data-mj-faq]');
      if (contenedor) {
        contenedor.querySelectorAll('[data-mj-faq-item]').forEach(cerrarFaqItem);
      }
      if (!abierto) abrirFaqItem(item);
    });
  });
}
